import { NavLink } from "react-router-dom";
import styled from "styled-components";
import { Button } from "@components/Button";

const ErrorPage = () => {
  return (
    <Wrapper>
      <div className="container error_404">
        <div>
          <h2>404</h2>
          <h3>UH OH! You're lost.</h3>
          <p>
            The page you are looking for does not exist. How you got here is a
            mystery. But you can click the button below to go back to the
            homepage.
          </p>

          <NavLink to="/">
            <Button>Go Back to Home</Button>
          </NavLink>
        </div>
      </div>
    </Wrapper>
  );
};

const Wrapper = styled.section`
  .container {
    padding: 3rem 0;
    text-align: left;
    max-width:1300px;
    margin:auto;
    padding:0 20px;


    h2 {
      font-size: 8rem;
    }

    h3 {
      font-size: 4.2rem;
    }

    p {
      margin: 2rem 0;
    }
  }
`;

export default ErrorPage;
